import React from 'react';
import $ from 'jquery';
import '@progress/kendo-theme-default/dist/all.css';
import { Button } from '@progress/kendo-react-buttons'
import { process ,distinct ,filterBy} from '@progress/kendo-data-query';
import { Mainfilter } from './Mainfilter.jsx';
import { Input } from '@progress/kendo-react-inputs';
import { Tooltip, Checkbox } from 'antd'
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";
import { Avatar } from "@progress/kendo-react-layout";

import {
    Grid, GridColumn as Column,
    GridColumnMenuFilter, GridToolbar,
    GridColumnMenuCheckboxFilter, GridDetailRow
} from '@progress/kendo-react-grid';
import { GridPDFExport } from '@progress/kendo-react-pdf';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import Lang from "../../../lang"

import { toast } from 'react-toastify';

import { TabelAction } from './tableAction.jsx';
import services from '../../../services.js';
import PDFGenerate from './pdfGenerate'
import CountUp from 'react-countup';
import { orderBy } from '@progress/kendo-data-query';
import {
    IntlProvider,
    load,
    LocalizationProvider,
  } from "@progress/kendo-react-intl";
  import numbers from "cldr-numbers-full/main/pt/numbers.json";
import currencies from "cldr-numbers-full/main/pt/currencies.json";
import caGregorian from "cldr-dates-full/main/pt/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/pt/dateFields.json";
import timeZoneNames from "cldr-dates-full/main/pt/timeZoneNames.json";

load(
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
);
// import esMessages from "./es.json";
// loadMessages(esMessages, "es-ES");
var moment = require('moment')
const dateFormat2 = "DD-MM-YYYY HH:mm";

let list = [];

let viewFor = '';

let castaKeyOrder = []

let columnlist = []
export class ColumnMenu extends React.Component {

    /*  Para renderizar o conteúdo html da página   */
    render() {
        return (
            <div>
                <GridColumnMenuFilter {...this.props} expanded={true} />
            </div>
        );
    }
}

export class ColumnMenuCheckboxFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredData: list 
        };
    }


    normalize = (str) => {
    return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[-_/.,]+/g, " ")
        .toLowerCase()
        .trim();
    };

    MySearchBox = () => {
        return <input onChange={this.filterData} />;
    };

    filterData = (event) => {
        const value = this.normalize(event.target.value);

        const searchTerms = value.split(" ").filter(Boolean);

        const filtered = list.filter((item) => {
            const fieldValue = this.normalize(
                item[this.props.column.field]
                    ? item[this.props.column.field].toString()
                    : ""
            );

            const fieldNoSpaces = fieldValue.replace(/\s+/g, "");

            return searchTerms.every(term => {
                const termNoSpaces = term.replace(/\s+/g, "");

                return (
                    fieldValue.includes(term) || 
                    fieldNoSpaces.includes(termNoSpaces)
                );
            });
        });

        this.setState({ filteredData: filtered });
    };
    
    render() {
        const sortedData = orderBy(this.state.filteredData, [
            { field: this.props.column.field, dir: "asc" }
        ]);

        const uniqueValues = distinct(sortedData, this.props.column.field);
        return (
            <LocalizationProvider language="pt-PT">
                <IntlProvider locale="pt">
                    <div>
                        <GridColumnMenuCheckboxFilter
                            {...this.props}
                            data={uniqueValues}
                            expanded={true}
                            searchBox={this.MySearchBox}
                        />
                    </div>
                </IntlProvider>
            </LocalizationProvider>
        );
    }
}



class HearderTooltip extends React.Component {
    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            <span className="cursor-pointer k-link" onClick={this.props.onClick}>
                <Tooltip title={this.props.title} color={"#808080"}>
                    {this.props.field}
                </Tooltip>
            </span>
        );
    }
}

let Defaultstate = {
    take: 20,
    skip: 0,
    group: [],
    exporting: false,
    modulename: ""
}
class DetailComponent extends GridDetailRow {
    /*  Para renderizar o conteúdo html da página   */
    
    render() {
        //console.log("this.props -> ", this.props);
        const dataItem = this.props.dataItem;
        const allParcelArrayObject = ["matrixArticle", "parcelProperty", "parcelExplorer", "legalFramework", "castaparc"]

        // console.log("jkdnxkjzn", this.props,columnlist)
        if (viewFor === 'vindima') {
            return (
                <div className="row">
                    {
                        columnlist.map((_row, i) => (
                            <div className="tab-section col-md-3" key={i}>
                                <div className="innerBox">
                                    <div className="display-content">
                                        <p><strong>{_row.field}({i + 1})</strong></p>
                                        <CountUp start={0} end={+dataItem[_row.field]} duration={6} />
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            );
        }else if (viewFor === "marcas") {
            const produtos = dataItem.produtos || [];

            return (
                <div className="row">
                    <div className="col-md-12">
                        <strong>Produtos associados à marca:</strong>

                        {produtos.length > 0 ? (
                            <ul style={{ marginTop: "10px", marginBottom: 0 }}>
                                {produtos.map((produto, index) => (
                                    <li key={produto.idProduto || index}>
                                        {produto.desProduto}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div style={{ marginTop: "10px" }}>
                                Não existem produtos associados.
                            </div>
                        )}
                    </div>
                </div>
            );
        }else if (viewFor === 'casta') {
            return (
                <div>
                    <ul>
                        {
                            castaKeyOrder.map((_k, i) => (
                                (_k === 'Casta' || _k === 'Fator Castas' || _k === 'Percentagem' ||
                                    _k === 'Fator DO Porto' || _k === 'Cor' || _k === 'Tipo Casta' || _k === 'Sinónimo') &&
                                <li style={{ listStyleType: "none", marginBottom: "5px" }} key={i}>
                                    <strong>{Lang.langCheck.langRequest(_k)} :</strong>
                                    &nbsp;{_k === 'Tipo Casta' ? (dataItem[_k] === 'N' ? "Douro : N" : "Porto : S") : dataItem[_k]}
                                </li>
                            ))
                        }
                    </ul>
                </div>
            )
        } else if (viewFor === 'parcelversions') {
            return (
                <div className="parcelversions" >
                    {
                        JSON.stringify(dataItem.bothRow.base.parcel) !== JSON.stringify(dataItem.bothRow.next.parcel) &&
                        <div className="row">
                            <b>Parcel ({Lang.langCheck.langRequest("Update")})</b>
                            <div className="col-md-12">
                                <div className="row innertable">
                                    <div className="col-md-4 headerrows">
                                        <b>{Lang.langCheck.langRequest("Key Name")}</b>
                                    </div>
                                    <div className="col-md-4 headerrows">
                                        <b>{Lang.langCheck.langRequest("Previous Value")}</b>
                                    </div>
                                    <div className="col-md-4 headerrows">
                                        <b>{Lang.langCheck.langRequest("New Value")}</b>
                                    </div>
                                    {
                                        Object.keys(dataItem.bothRow.base.parcel).map((_k) => (
                                            dataItem.bothRow.base.parcel[_k] !== dataItem.bothRow.next.parcel[_k] &&
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        {_k}
                                                    </div>
                                                    <div className="col-md-4">
                                                        {
                                                            dataItem.bothRow.base.parcel[_k]
                                                        }
                                                    </div>
                                                    <div className="col-md-4">
                                                        {dataItem.bothRow.next.parcel[_k]}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    {
                        allParcelArrayObject.map((modulename) => (
                            JSON.stringify(dataItem.bothRow.base[modulename]) !== JSON.stringify(dataItem.bothRow.next[modulename]) &&
                            <>
                                {
                                    dataItem.bothRow.base[modulename].length < dataItem.bothRow.next[modulename].length &&
                                    <div className="row">
                                        <b>{Lang.langCheck.langRequest(modulename)} {Lang.langCheck.langRequest("Add")} ({dataItem.bothRow.next[modulename].length - dataItem.bothRow.base[modulename].length})</b>
                                        <div className="row innertable">
                                            {
                                                dataItem.bothRow.next[modulename].map((r, index) => (
                                                    dataItem.bothRow.base[modulename].length <= index &&
                                                    <>
                                                        {
                                                            Object.keys(r).map((rk) => (
                                                                <div className="col-md-12">
                                                                    <div className="row">
                                                                        <div className="col-md-6">
                                                                            {rk}
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            {r[rk]}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            ))
                                                        }
                                                        <hr />
                                                    </>
                                                ))
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    dataItem.bothRow.base[modulename].length > dataItem.bothRow.next[modulename].length &&
                                    <div className="row">
                                        <b>{Lang.langCheck.langRequest(modulename)} {Lang.langCheck.langRequest("Delete")} ({dataItem.bothRow.base[modulename].length - dataItem.bothRow.next[modulename].length})</b>
                                        <div className="row innertable">
                                            {
                                                dataItem.bothRow.base[modulename].map((r, index) => (
                                                    dataItem.bothRow.next[modulename].length <= index &&
                                                    <>
                                                        {
                                                            Object.keys(r).map((rk) => (
                                                                <div className="col-md-12">
                                                                    <div className="row">
                                                                        <div className="col-md-6">
                                                                            {rk}
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            {r[rk]}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                        <hr />
                                                    </>
                                                ))
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    dataItem.bothRow.base[modulename].length === dataItem.bothRow.next[modulename].length &&
                                    <div className="row">
                                        <b>{Lang.langCheck.langRequest(modulename)} ({Lang.langCheck.langRequest("Update")})</b>
                                        <div className="col-md-12">
                                            <div className="row innertable">
                                                <div className="col-md-3 headerrows">
                                                    <b>{Lang.langCheck.langRequest("Row num")}</b>
                                                </div>
                                                <div className="col-md-3 headerrows">
                                                    <b>{Lang.langCheck.langRequest("Key Name")}</b>
                                                </div>
                                                <div className="col-md-3 headerrows">
                                                    <b>{Lang.langCheck.langRequest("Previous Value")}</b>
                                                </div>
                                                <div className="col-md-3 headerrows">
                                                    <b>{Lang.langCheck.langRequest("New Value")}</b>
                                                </div>
                                                {
                                                    dataItem.bothRow.base[modulename].map((row, i) => (
                                                        Object.keys(row).map((_k) => (
                                                            row[_k] !== dataItem.bothRow.next[modulename][i][_k] &&
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="col-md-3">
                                                                        {i + 1}
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        {_k}
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        {
                                                                            row[_k]
                                                                        }
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        {dataItem.bothRow.next[modulename][i][_k]}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        )
                                                        )
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }

                            </>
                        ))
                    }
                </div>
            )
        }
        else if (viewFor === "auditdetails") {
            let history = {};
            try {
                history = JSON.parse(dataItem['último registro']);
            } catch (error) {
            }
            // console.log(history);
            
            return (
                <div className="row">
                    <div className="col-md-12">
                        <b>Audit ({Lang.langCheck.langRequest("último registro")})</b>
                    </div>

                    <div className="col-md-12">
                        <div className="row innertable">
                            <div className="col-md-6 headerrows">
                                <b>{Lang.langCheck.langRequest("Key Name")}</b>
                            </div>
                            <div className="col-md-6 headerrows">
                                <b>{Lang.langCheck.langRequest("Previous Value")}</b>
                            </div>
                            {
                                Object.keys(history).map((_k) => (
                                   !history[_k] instanceof Object && !Array.isArray(history[_k]) &&
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-4">
                                                {_k}
                                            </div>
                                            <div className="col-md-4">
                                                {
                                                   history[_k]
                                                }
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            )
        }
        else if (viewFor === "rotulos") {
            return (
                <>
                {/* <div class="row">
                    <div class="col-md-12 rotuloDesc">
                        <div className="rotuloDesc1">Rótulos aprovados: {dataItem['rotuloaprovodo']}</div>
                    </div>
                </div> */}
                <div>
                    <div class="row">
                        <div class="col-md-12 mb-2" style={{fontSize:"14px"}}>
                            <strong>Indice Calorico</strong>
                        </div>
                    </div>
                    <div class="row">
                    <div class="col-md"><strong>Valor energético:</strong>&nbsp;{dataItem['Valor energético']}</div>
                    <div class="col-md"><strong>Carbohidratos:</strong>&nbsp; {dataItem['Carbohidratos']}</div>
                    <div class="col-md"><strong>Proteinas:</strong>&nbsp; {dataItem['Proteinas']}</div>
                    <div class="col-md"><strong>Fibra alimentar:</strong>&nbsp; {dataItem['Fibra alimentar']}</div>
                    <div class="col-md"><strong>Sódio:</strong>&nbsp; {dataItem['Sódio']}</div>
                    </div>
                </div>
            </>
            )
        }else if(viewFor === "notificacoes"){
            var address = dataItem['conteudo'];
            var splitaddr = address.split(',');
        
            var htmlContent = splitaddr
            .map(addr => `<i>${addr.trim()}</i>`)
            .join('<br />'); // Adiciona <br /> entre os itens
    

            return (
                <>
                    <div className="row">
                <div className="col-md-4" dangerouslySetInnerHTML={{ __html: htmlContent }} />
            </div>
                </>
            );
        }
        else if (viewFor === "conta_movimento") {
            // console.log("data item 88877",dataItem)
            return (
                <>
                <div className="row">
                    {/* <div className="col-md-4">Movimento :{dataItem['Movimento']}</div> */}
                    <div className="col-md-4">Num Documento : {dataItem['Num Documento']}</div>
                    <div className="col-md-4">Documento Associado: {dataItem['numeroDocumento']}</div>
                </div>
                <div className="row">
                    <div className="col-md-4 mt-1">Descrição : {dataItem['Descrição']}</div>
                    <div className="col-md-4 mt-1">Data do Movimento : {dataItem['Data Movimento']}</div>
                </div>
                <div className="row">
                    <div className="col-md-4 mt-1">Valor do Movimento : {dataItem['Valor da Operação']}</div>
                    <div className="col-md-4 mt-1">Saldo Prévio : {dataItem['Saldo Previo']}</div>
                </div>
                <div className="row">
                    <div className="col-md-4 mt-1">Saldo Final : {dataItem['Saldo Final']}</div>
                   { dataItem['Saldo Cativo'] ? <div className="col-md-4 mt-1">Saldo Cativo : {dataItem['Saldo Cativo']}</div>: <></>}
                </div>
                {/* <div className="row">
                    <div className="col-md-4 mt-1">Data de Engarrafamento / degorgement : {"ND"}</div>
                    <div className="col-md-4 mt-1">Data de Constituição de Lote : {"ND"}</div>
                </div> */}
                </>
            )
        }
        else if (viewFor === "selosRastreabilidade") {
            return (
                <>
                <div className="row">
                    <div className="col-md-4"><span className="font-weight-bold">Intervalo Gráfica :</span> {dataItem['graficaNumeroInicial']}-{dataItem['graficaNumeroFinal']}</div>
                    <div className="col-md-4"><span className="font-weight-bold">Nº Registo :</span> {dataItem['numeroRegisto']}</div>
                    <div className="col-md-4"><span className="font-weight-bold">País :</span> {dataItem['pais']}</div>

                </div>
                <div className="row">
                    <div className="col-md-4 mt-1"><span className="font-weight-bold">Intervalo Entidade:</span> {dataItem['entidadeNumeroInicial']}-{dataItem['entidadeNumeroFinal']}</div>
                    <div className="col-md-4 mt-1"><span className="font-weight-bold">Correlativa :</span> {dataItem['correlativa']}</div>
                    <div className="col-md-4 mt-1"><span className="font-weight-bold">Acidez :</span> {dataItem['acidez']}</div>
                </div>
                <div className="row">
                    <div className="col-md-4 mt-1"><span className="font-weight-bold">Intervalo Aposição :</span> {dataItem['aposicaoNumeroInicial']}-{dataItem['aposicaoNumeroFinal']}</div>
                    <div className="col-md-4 mt-1"><span className="font-weight-bold">Marca :</span> {dataItem['marca']}</div>
                    <div className="col-md-4 mt-1"><span className="font-weight-bold">Madeira :</span> {dataItem['madeira']}</div>

                </div>
                <div className="row">
                    <div className="col-md-4 mt-1"><span className="font-weight-bold">Data Aposição :</span> {moment(dataItem['dataAposicao']).format(dateFormat2)}</div>
                    <div className="col-md-4 mt-1"><span className="font-weight-bold">Ano:</span> {dataItem['anoProduto']}</div>

                    <div className="col-md-4 mt-1"><span className="font-weight-bold">Doçura :</span> {dataItem['grauDocura']}</div>
                </div>
                <div className="row">
                    <div className="col-md-4 mt-1"><span className="font-weight-bold">Data Entrega :</span> {moment(dataItem['dataEntrega']).format(dateFormat2)}</div>
                    <div className="col-md-4 mt-1"><span className="font-weight-bold">Cor :</span> {dataItem['corProduto']}</div>

                    <div className="col-md-4 mt-1"><span className="font-weight-bold">TAV :</span> {dataItem['teorAlcoolico']}</div>
                </div>
                
                </>
            )
        }
        else {
            return (
                <div></div>
            )
        }
    }
}

let actionTable;
class TlkTable extends React.Component {
    gridPDFExport;
    _export;
    /* Primeiro passo na acomodação da classe */
    // constructor(props) {
    //     super(props);

    // let initialState = Defaultstate;

    // const key = this.getPersistenceKey();
    // const persistedState = localStorage.getItem(key);

    // if (persistedState) {
    //     initialState = JSON.parse(persistedState);
    // }

    //  this.state = this.createAppState(initialState);
    //     // super(props);
    //     // this.state = this.createAppState(Defaultstate);
    //     // this.TabelAction = TabelAction({
    //     //     rowbuttonAction: this.rowbuttonAction,
    //     //     actionbuttons: this.props.actionbuttons,
    //     //     deleteFunc: this.props && this.props.deleteFunc && this.props.deleteFunc
    //     // });
    //     // console.log('Construtor tlktable');
    //     // console.log(this.props.columnlist);
    // }
    constructor(props) {
    super(props);

    let initialState = Defaultstate;

    const key = this.getPersistenceKey();
    const persistedState = localStorage.getItem(key);

    if (persistedState) {
        initialState = JSON.parse(persistedState);
    }

    this.state = {
        ...this.createAppState(initialState),

        // guardar widths das colunas
        columnWidths: {}
    };

    // bind do resize
    this.onColumnResize = this.onColumnResize.bind(this);
}
componentDidMount() {
    const key = this.getPersistenceKey();
    const persistedState = localStorage.getItem(key);
    if (persistedState) {
        this.setState(prev => ({
            dataState: { ...prev.dataState, ...JSON.parse(persistedState) },
            result: process(this.state.completelist, JSON.parse(persistedState))
        }));
    }
}

onColumnResize = (event) => {
    const { field, newWidth } = event;

    this.setState(prev => ({
        columnWidths: {
            ...prev.columnWidths,
            [field]: newWidth
        }
    }));
}

    clearFilters = () => {
        let dataState = { ...this.state.dataState };

        // Limpar filtros
        if (dataState.filter) {
            dataState.filter.filters = [];
        }

        // Resetar resultados
        const data = this.state.completelist;
        const result = data;

        dataState.total = data.length;

        // Atualizar o estado da grid
        this.setState({
            dataState,
            result
        }, () => {
            // Atualizar persistência
            const key = this.getPersistenceKey(); // função que cria uma chave única da grid
            localStorage.setItem(key, JSON.stringify(dataState));
        });
    }
    export = () => {
        let todownload = this.getOnlyData();
        // this.setState({ exporting: true },()=>{
        services.exportFiles.ExcelDownload(todownload, this.props.columnlist);
        // this._export.save(todownload);

        // });
        // this.ExportDone();
    }

    exportPDF = () => {
        let todownload = this.getOnlyData();
        // this.setState({ exporting: true },()=>{
        services.exportFiles.pdfDownloader(todownload, this.props.columnlist);
        // });
        // this.ExportDone();
    }

    ExportDone = () => {
        setTimeout(() => {
            this.setState({ exporting: false });
        }, 250);
    }

    getOnlyData = () => {
        let listarray = [...list]
        let final = [];
        listarray.map((_r, _i) => {
            if (Object.keys(_r).length > 0)
                final.push(_r);
        });
        return final;
    }

    rowbuttonAction = (action, dataItem) => {
        this.props.ActionPerform(action, dataItem);
    }

    createAppState = (dataState) => {
        viewFor = this.props.viewFor;
        castaKeyOrder = this.props.castaKeyOrder;
        let groupfield = [];
        let sumfields = {}
        let propdata = {}
        // console.log("dataState1", dataState);
        if (this.state) {
            propdata = { ...this.state.propdata }
        }

        if (this.props.tlkState) {
            dataState = { ...this.props.tlkState }
        }

        else if (propdata.modulename !== this.props.modulename || propdata.date !== this.props.date) {
            dataState = Defaultstate
            dataState.group = this.props.groupfield;
            
        }
        // console.log("dataState2", dataState);
        let aggregates = this.props.aggregates;
        
        if (aggregates) {
            const groups = dataState.group;
            if (groups) { groups.map(group => group.aggregates = aggregates); }
            aggregates.map((row, index) => (
                sumfields[row.field] = row
            ))
            
        }
        let listdata = []
        if (this.state && this.props.sendDatatoTlkTable) {
            listdata = this.state.completelist;
            list = listdata;
        } else if (this.props.list) {
            listdata = this.props.list;
            list = listdata;
        }
            console.log(process(listdata.slice(0), dataState))
            dataState.total = process(listdata.slice(0), dataState).total || this.props.totalcount || parseInt(window.localStorage.getItem('table_total'));
        
     
        if (this.props.tableFilters) {
            this.props.tableFilters(dataState);
        }
        // console.log("dataState", dataState);
        // listdata = this.getNewListData(listdata);
        return {
            result: process(listdata.slice(0), dataState),
            completelist: listdata,
            dataState: dataState,
            groupfield,
            propdata: this.props,
            sumfields,
            exporting: false,
            per_col_width: this.getColWidth(dataState),
            customrow: this.props.customrow || {},
            checkedInvoice: {}
        };
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {
        let groupfield = [];
        let sumfields = {};
        viewFor = this.props.viewFor;
        castaKeyOrder = this.props.castaKeyOrder
        let dataState = { ...this.state.dataState }
        if (this.props.date !== preProp.date) {
            // console.log("OK1");
            if (this.props.tlkState) {
                dataState = { ...this.props.tlkState }
            } else if (dataState.modulename !== this.props.modulename) {
                dataState = Defaultstate
                dataState.group = this.props.groupfield || []
            }
            dataState.total = parseInt(window.localStorage.getItem('table_total'));
            let aggregates = this.props.aggregates;
            if (aggregates) {
                const groups = dataState.group;
                if (groups) { groups.map(group => group.aggregates = aggregates); }
                aggregates.map((row, index) => (
                    sumfields[row.field] = row
                ))
                
            }
            let listdata = []
            // console.log(">>>>>>>>>>>>>>",this.props)
            if (this.state && this.props.sendDatatoTlkTable) {
                listdata = this.state.completelist;
                list = listdata;
            } else if (this.props.list) {
                listdata = this.makedata(this.props.list, dataState);
                list = listdata;
            }
            if (listdata.length === 0 && this.props.sendDatatoTlkTable) {
                let json = this.props.sendDatatoTlkTable(dataState)
                if (json) {
                    Promise.all([json]).then((values) => {
                        this.dataRecieved(values[0]);
                    });
                    return null
                }
            }
            // console.log('Teste');
            // console.log(listdata);
            // listdata = this.getNewListData(listdata)
            this.setState({
                result: process(listdata.slice(0), dataState),
                dataState: dataState,
                completelist: listdata,
                modulename: this.props.modulename,
                groupfield,
                sumfields,
                exporting: false,
                per_col_width: this.getColWidth(dataState),
            });
        }
    }

    getNewListData = (listdata) => {
        let newListData = []
        listdata.map(_r => {
            Object.keys(_r).map(_key => {
                if (_r[_key] === "null" || _r[_key] === "Null" || _r[_key] === null || _r[_key] === undefined || _r[_key] === '') {
                    _r[_key] = 'nd'
                }
                if (_r[_key] === true) {
                    _r[_key] = 'Sim'
                }
                if (_r[_key] === false) {
                    _r[_key] = 'Não'
                }
            })
            newListData.push(_r)
        })
        return newListData
    }

    getPersistenceKey = () => {
        console.log("keypersistence", `TlkTable_${this.props.modulename || ""}_${this.props.viewFor || ""}_${window.location.pathname}`)
    return `TlkTable_${this.props.modulename || ""}_${this.props.viewFor || ""}_${window.location.pathname}`;
    
}

    dataStateChange = (event) => {
        // if (this.props.tableFilters) {
        //     this.props.tableFilters(event.data)
        // } else {
        //     this.setState(this.createAppState(event.data));
        // }
        const dataState = event.data;
    
        this.setState(this.createAppState(dataState), () => {
            const key = this.getPersistenceKey();
            localStorage.setItem(key, JSON.stringify(this.state.dataState));
        });

        if (this.props.tableFilters) {
            this.props.tableFilters(event.data);
        }
    }

    expandChange = (event) => {
        if (this.props.collepsview) {
            event.dataItem.expanded = !event.dataItem.expanded;
            this.forceUpdate();
        } else {
            event.dataItem[event.target.props.expandField] = event.value;
            this.setState({
                result: Object.assign({}, this.state.result),
                dataState: this.state.dataState
            });
        }
    }

    gettotalrow = (row) => {
        let Total = 0;
        if (row["QT"]) {
            Total = (parseFloat(row['Valor UN']) * parseFloat(row["QT"]));
            row.complete_services_amount = Total;
            if (row.tax_id) {
                let tax = {};
                this.props.tax_list.map((_r) => {
                    if (parseInt(_r.id) === parseInt(row.tax_id)) {
                        tax = _r
                    }
                })
                row.tax_type = tax.tax_type;
                row.tax_percent = parseFloat(tax.tax_percent);
                row.service_tax = Total * parseFloat(tax.tax_percent) / 100;
                row.valor_cativo = 0;
                Total = Total + Total * parseFloat(tax.tax_percent) / 100;
            } else {
                row.tax_id = null;
                row.tax_type = "";
                row.service_tax = 0;
                row.valor_cativo = 0;
                row.tax_percent = 0;
            }
        }
        row.Valor = Total;
        return row;
    }


    AddServices = (e, row) => {
        let customrow = this.state.customrow;
        row["QT"] = parseFloat(e.target.value)
        customrow[row.id] = this.gettotalrow(row);
        if (!e.target.value || e.target.value === 0) {
            delete customrow[row.id];
        }
        this.props.ActionPerform("AddServices", customrow);
        this.setState({
            customrow
        })
    }

    handleInputBoletim = (e,row) => {
        let fieldName = e.target.name
        row[e.target.name] = isNaN(+(e.target.value)) && (e.target.name === 'Percentagem' || e.target.name === 'Nº Artigo') ? '' : e.target.value 
        this.props.ActionPerform(this.props.modulename, row,fieldName)
    }

    setServicestax = (e, row) => {
        let customrow = { ...this.state.customrow };

        if (e.target.value) {
            row.tax_id = parseInt(e.target.value);
        } else {
            row.tax_id = null;
        }
        customrow[row.id] = this.gettotalrow(row);
        this.props.ActionPerform("AddServices", customrow);
        this.setState({
            customrow
        })
    }
    handleCheck = (e) => {
        let id = e.target.value;
        let checkedInvoice = { ...this.state.checkedInvoice };
        if (e.target.checked) {
            checkedInvoice["id-" + id] = id;
        } else {
            delete checkedInvoice["id-" + id]
        }
        this.setState({
            checkedInvoice
        })
    }

    generateDocument = () => {
        let checkedInvoice = { ...this.state.checkedInvoice };
        this.props.ActionPerform("checkedInvoice", checkedInvoice);
    }

    grepif = () => {
        let checkedInvoice = { ...this.state.checkedInvoice };
        toast.error("Virá em breve ...")
        // this.props.ActionPerform("checkedInvoice", checkedInvoice);
    }

    cellRender = (tdElement, cellProps) => {
        if (this.props.modulename === "FaturasEmitir") {
            if (cellProps.field === "Check") {
                if (cellProps.dataItem.invoice_url) {
                    return (<td></td>)
                } else {
                    return (<td>
                        <Checkbox
                            onChange={(e) => this.handleCheck(e)}
                            value={cellProps.dataItem.id}
                            checked={this.state.checkedInvoice["id-" + cellProps.dataItem.id]}
                        ></Checkbox>
                    </td>)
                }
            }
        }
        if (this.props.modulename === "GERFIP") {
            if (cellProps.field === "Check") {
                if (cellProps.dataItem.fesial_url) {
                    return (<td></td>)
                } else {
                    return (<td>
                        <Checkbox
                            onChange={(e) => this.handleCheck(e)}
                            value={cellProps.dataItem.id}
                            checked={this.state.checkedInvoice["id-" + cellProps.dataItem.id]}
                        ></Checkbox>
                    </td>)
                }
            }
        }
        if (this.props.modulename === "TesourariaEmissãodeRecibos") {
            if (cellProps.field === "Check") {
                if (cellProps.dataItem.document_url) {
                    return (<td></td>)
                } else {
                    return (<td>
                        <Checkbox
                            onChange={(e) => this.handleCheck(e)}
                            value={cellProps.dataItem.id}
                            checked={this.state.checkedInvoice["id-" + cellProps.dataItem.id]}
                        ></Checkbox>
                    </td>)
                }
            }
        }
        if (this.props.modulename === "TesourariaContacorrente") {
            if (cellProps.field === "Nº Doc") {
                return (<td style={{ color: "red" }}>
                    <span className="cursor-pointer" data-toggle="modal" data-target="#vindima-modal" onClick={() => this.rowbuttonAction("detailPopUp", cellProps.dataItem)} >
                        {cellProps.dataItem[cellProps.field]}
                    </span>
                </td>)
            }
        } if (this.props.modulename === "Adicionar Movimento") {
            if (cellProps.field === "QT") {
                return (<td> <Input type={"number"}
                    value={this.state.customrow[cellProps.dataItem.id] ? this.state.customrow[cellProps.dataItem.id]['QT'] : ""}
                    onChange={(e, row) => this.AddServices(e, cellProps.dataItem)} /> </td>);
            } else if (cellProps.field === "Valor") {
                return (<td> <Input readOnly={true} value={this.state.customrow[cellProps.dataItem.id] ? services.money.format(this.state.customrow[cellProps.dataItem.id].Valor) : ""} /> </td>);
            } else if (cellProps.field === "Valor UN") {
                return (<td> {services.money.format(cellProps.dataItem[cellProps.field])} </td>);
            } else if (cellProps.field === "IVA") {
                return (<td>
                    <select
                        style={{ width: "100%" }}
                        value={this.state.customrow[cellProps.dataItem.id] ? this.state.customrow[cellProps.dataItem.id].tax_id : ""}
                        onChange={(e, row) => this.setServicestax(e, cellProps.dataItem)} >
                        <option value="">No Tax</option>
                        {
                            this.props.tax_list.map((row) => (
                                <option value={row.id}>{row.tax_percent}% - {row.tax_type}</option>
                            ))
                        }
                    </select>
                </td>);
            }
        }
        if(this.props.modulename === 'abrigo' || this.props.modulename === 'naturezaDoTerreno' || this.props.modulename === 'pedregosidade'){
            if(cellProps.field === 'Classe'){
                return (<td>
                    <select
                        style={{ width: "100%" , height:"30px"}}
                        name={cellProps.field}
                        disabled={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                        value={cellProps.dataItem[cellProps.field] || ""}
                        onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} >
                        <option value="">Selecione</option>
                        {
                            this.props.modulename === 'abrigo' ?
                            this.props.all_list && this.props.all_list.Abrigo && this.props.all_list.Abrigo.map((row,index) => (
                                <option key={index} value={row.idtpabrigo}>{row.descr}</option>
                            ))
                            :
                            this.props.modulename === 'naturezaDoTerreno' ?
                            this.props.all_list && this.props.all_list.Natureza && this.props.all_list.Natureza.map((row,index) => (
                                <option key={index} value={row.idtpnaturterr}>{row.descr}</option>
                            ))
                            :
                            this.props.modulename === 'pedregosidade' &&
                            this.props.all_list && this.props.all_list.Pedregosidade && this.props.all_list.Pedregosidade.map((row,index) => (
                                <option key={index} value={row.idtppedregosidade}>{row.descr}</option>
                            ))
                        }
                    </select>
                </td>);
            }
            if(cellProps.field === 'Percentagem'){
                return (<td> <Input type={"text"}
                    name={cellProps.field}
                    readOnly={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                    value={ cellProps.dataItem[cellProps.field] ||""}
                    onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>);
            }
        }
        if(this.props.modulename === 'compassoPlantacao'){
            if(cellProps.field === 'Linha 1 (cm)' || cellProps.field === 'Linha 2 (cm)' || cellProps.field === 'Linha 3 (cm)' || cellProps.field === "Entrelinha 1 (cm)" || cellProps.field === "Entrelinha 2 (cm)"){
                return (<td> <Input type={"text"}
                    name={cellProps.field}
                    readOnly={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                    value={ cellProps.dataItem[cellProps.field] ||""}
                    onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>);
            }
        }
        if(this.props.modulename === 'artigoMatricial'){
            if(cellProps.field === 'Nº Artigo' || cellProps.field === 'Fração'){
                return (<td> <Input type={"text"}
                    name={cellProps.field}
                    readOnly={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                    value={ cellProps.dataItem[cellProps.field] ||""}
                    onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>);
            }
        }
        if(this.props.modulename === 'detailsDoPovimento'){
            // console.log("propsps",this.props)
            if(cellProps.field === 'Bacelos' || cellProps.field === 'Enxertos (1 ano)' || 
                cellProps.field === 'Falhas' || cellProps.field === "Videiras (2 anos)" || 
                cellProps.field === "Videiras (3 anos)" || cellProps.field === "Videiras (4-25 anos)" ||
                cellProps.field === "Videiras (> 25 anos)"){
                return (<td> <Input type={"text"}
                    name={cellProps.field}
                    readOnly={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                    value={ cellProps.dataItem[cellProps.field] ||""}
                    onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>
                );
            }
        }
        if(this.props.modulename === 'modoDeConducao'){
            if(cellProps.field === 'Forma' || cellProps.field === 'Tipo'){
                return (<td>
                    <select
                        style={{ width: "100%" , height:"30px"}}
                        name={cellProps.field}
                        disabled={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                        value={cellProps.dataItem[cellProps.field] || ""}
                        onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} >
                        <option value="">Selecione</option>
                        {
                            cellProps.field === 'Forma' ?
                            this.props.all_list && this.props.all_list.Forms && this.props.all_list.Forms.map((row,index) => (
                                <option key={index} value={row.idtparmacao}>{row.descr}</option>
                            ))
                            :
                            cellProps.field === 'Tipo' &&
                            this.props.all_list && this.props.all_list.Tipo && this.props.all_list.Tipo.map((row,index) => (
                                <option key={index} value={row.idtparmacaoforma}>{row.descr}</option>
                            ))
                        }
                    </select>
                </td>);
            }
            if(cellProps.field === 'Altura - 1º Arame (cm)'){
                return (<td> <Input type={"text"}
                    name={cellProps.field}
                    readOnly={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                    value={ cellProps.dataItem[cellProps.field] ||""}
                    onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>);
            }
        }
        if(this.props.modulename === 'portaEnxertos'){
            if(cellProps.field === 'Tipo'){
                return (<td>
                    <select
                        style={{ width: "100%" , height:"30px"}}
                        name={cellProps.field}
                        disabled={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                        value={cellProps.dataItem[cellProps.field] || ""}
                        onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} >
                        <option value="">Selecione</option>
                        {
                            this.props.all_list  && this.props.all_list.Portaenxertos && this.props.all_list.Portaenxertos.map((row,index) => (
                                <option key={index} value={row.idtpportaenxertos}>{row.descr}</option>
                            ))
                        }
                    </select>
                </td>);
            }
            if(cellProps.field === 'Percentagem (Tipo)'){
                return (<td> <Input type={"text"}
                    name={cellProps.field}
                    readOnly={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                    value={ cellProps.dataItem[cellProps.field] ||""}
                    onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>);
            }
        }
        else if (cellProps.field === "Limite pag") {
            let a = moment(new Date());
            let b = moment(cellProps.dataItem[cellProps.field]);
            if (a.diff(b, 'days') > 0)
                return (<td style={{ color: "red" }}>{cellProps.dataItem[cellProps.field]}</td>);
            else
                return (<td style={{ color: "orange" }}>{cellProps.dataItem[cellProps.field]}</td>);

        } else if (cellProps.field === "Sinalizado") {
            return (<td className="text-inactive"> <i className="fa fa-flag ml-5" aria-hidden="true" style={{ color: cellProps.dataItem.Sinalizado }}></i> </td>);
        } else if (cellProps.rowType === 'groupFooter') {
            let row = this.state.sumfields[cellProps.field]

            if (row) {
                return (
                    <td className="GridsumField">
                        {cellProps.dataItem.aggregates[cellProps.field].sum}
                    </td>
                );
            }
            else {
                if (cellProps.field === "Classe")
                    return (
                        <td className="GridsumField">
                            Total {cellProps.dataItem.field} :
                        </td>
                    );
            }
        }
        else if (cellProps.rowType !== 'groupHeader') {
            if (cellProps.field === "Estado"
                && (cellProps.dataItem.status === 1 ||
                    cellProps.dataItem.status === "1" ||
                    (cellProps.dataItem.status && (cellProps.dataItem.status.toUpperCase() === "ACTIVE" ||
                        cellProps.dataItem.status.toUpperCase() === "A"))
                    || cellProps.dataItem.Estado && (
                        cellProps.dataItem.Estado.toUpperCase() === "A" ||
                        cellProps.dataItem.Estado.toUpperCase() === "ATIVO"
                        || cellProps.dataItem.Estado.toUpperCase()==="APROVADO"
                    )
                )) {
                return (
                    <td className="text-active">
                        {cellProps.dataItem['Estado'] || 'Ativo'} 
                    </td>
                );
            } else if (cellProps.field === "Estado") {
                return (<td className="text-inactive"> {cellProps.dataItem['Estado']} </td>);
            }
            else if (cellProps.field === "Declaração") {
                return (<td > {cellProps.dataItem["Declaração"] === 1 ? "Sim" : "Não"} </td>);
            } else if (cellProps.field === "Legalizável") {
                return (<td > {cellProps.dataItem["Legalizável"] === 1 ? "Sim" : "Não"} </td>);
            } else if (cellProps.field === "Classe") {
                return (<td > {cellProps.dataItem["Classe"] === 1 ? "A" : cellProps.dataItem["Classe"]} </td>);
            } 
            
            // else if(cellProps.field === 'Doçura') {
            //     return (<td className="resumoTableCol" >{cellProps.dataItem['Doçura']}</td>);
            // }else if(cellProps.field === 'Acidez (%)') {
            //     return (<td className="resumoTableCol" >{cellProps.dataItem['Acidez (%)']}</td>);
            // }
        }
        if (cellProps.dataItem[cellProps.field] === "") {
            return (<td >nd</td>)
        }
        return tdElement;
    }



    makedata = (data, dataState) => {
        let returnData = [];
        while (returnData.length < (dataState.skip)) {
            returnData.push({});
        }
        data.map((row, index) => {
            returnData.push(row);
        })
        return returnData;
    }

    getColWidthParcela = (dataState) => {
        // console.log("dataset 441 ", dataState)
        let totalCol = this.props.columnlist.length + 1;
        let totalwidth = $(".table-responsive").width();
        let totalGrouping = dataState.group && dataState.group.length > 0 ? dataState.group.length : 0;
        let groupingWidth = totalGrouping * 32;
        let per_Col_width = (totalwidth - 140 - (groupingWidth)) / (totalCol - 1);
        // console.log("widths: ", totalCol, totalwidth, totalGrouping, groupingWidth, per_Col_width)
        return per_Col_width;
    }

    getColWidth = (dataState) => {
        // console.log("the responsive 551")
        let totalCol = this.props.columnlist.length;
        if (!this.props.notAction) {
            totalCol += 1
        }
        let totalwidth = this.props.totalWidth ? this.props.totalWidth : $(".table-responsive").width();
        if (this.props.fixTableWidth && Object.keys(this.props.groupfield).length > 0) {
            totalwidth -= 25
        }
        let totalGrouping = dataState.group && dataState.group.length > 0 ? dataState.group.length : 0;
        let groupingWidth = totalGrouping * 32;
        let per_Col_width = (totalwidth - 32 - (groupingWidth)) / (totalCol);
        // console.log("widths: ", totalCol, totalwidth, totalGrouping, groupingWidth, per_Col_width)
        return per_Col_width;
    }

    dataRecieved = (listdata) => {
        if (Array.isArray(listdata)) {
            list = listdata;
            let dataState = { ...this.state.dataState };
            listdata = this.makedata(listdata, dataState);
            dataState.total = this.props.totalcount || parseInt(window.localStorage.getItem('table_total'));
            this.setState({
                dataState,
                result: process(listdata.slice(0), dataState),
                completelist: listdata
            });
        }
    }

    Tooltip = (row, i) => {
        let tooltip = null;
        //console.log("ROW GRID -> ", row);
        if (this.props.tooltips && this.props.tooltips[row.field]) {
            tooltip = (
                <Column
                    key={i}
                    width={this.state.columnWidths[row.field] || 220}
                    //width={this.props.columnwidth ? this.props.columnwidth : this.state.per_col_width}
                    field={row.field}
                    title={this.props.tooltips[row.field]}
                    headerCell={HearderTooltip}
                    columnMenu={this.props.noFilterShow ? '' : (row.columnMenuType ? ColumnMenuCheckboxFilter : ColumnMenu)}
                   
                  
                    cell={props => {
                        if(row.field == "estado" || row.field == "Estado" || row.field == "estadoRequisicao") {
                            if(props.dataItem[props.field] == "Aprovado"){
                                return <td className='badge-sucess' style={{textAlign: 'left'}}>{props.dataItem[props.field]}</td>
                            }else{
                                return <td style={{textAlign: 'left'}}>{props.dataItem[props.field]}</td>
                            }
                        }
                        else if(row.columnMenuType == "number") {
                          return <td style={{textAlign: 'right'}}>{props.dataItem[props.field]}</td>
                        }
                        else{
                            return <td style={{textAlign: 'left'}}>{props.dataItem[props.field]}</td>
                        }
                      }}
                    />
            )
        } else {
            tooltip = (
                <Column
                    key={i}
                    //width={this.state.columnWidths[row.field] || 220}
                   // width={this.props.columnwidth ? this.props.columnwidth : this.state.per_col_width}
                    field={row.field}
                    columnMenu={this.props.noFilterShow ? '' : (row.columnMenuType ? ColumnMenuCheckboxFilter : ColumnMenu)}
                    // footerCell={props => {
                    //     let calcCol = row.footerCell;
                    //     if(row.footerCell !== undefined){
                    //         let total = 0;
                    //         let aggregates = this.props.aggregates;
                    //         let dataState = { ...this.props.tlkState };
                    //         console.log(dataState, "TLK")
                    //         const groups = dataState.group;
                    //         if (groups) { groups.map(group => group.aggregates = aggregates); }
                                
                    //         console.log(groups, "AGG")

                    //         this.state.completelist.map((item, index) => {
                    //             total += item[calcCol];
                    //         })
    
                    //         return (<td colSpan={props.colSpan} style={props.style}>
                    //                 Total: {total}
                    //             </td>)
                    //     }
                    //     else{
                    //         return null;
                    //     }

                    // }
                    // }
                   
                    cell={props => {
                        // if(row.field == "Menção Complementar"){
                            
                        //     //return <td><button onClick={this.rowbuttonAction()}>{ props.dataItem[props.field]}</button></td>
                        //     // return <td><a data-toggle="modal" data-target='#MencaoComplementar-left-popup' href= '#' >{ props.dataItem[props.field]}</a></td>
                        //     return <td><span data-toggle="modal" data-target='#MencaoComplementar-left-popup' >{ props.dataItem[props.field]}</span></td> 
                        // }
                        if(row.field == "estado" || row.field == "Estado" || row.field =="estadoMovimento" || row.field =="Situação"|| row.field =="Estado Auto" || row.field == "Estado Requisição" || row.field == "Ativo"|| row.field == "Irrevogável") {
                            if(props.dataItem[props.field] === "Aprovada" || props.dataItem[props.field] === "Aprovado" || props.dataItem[props.field] ==="Ativo" || props.dataItem[props.field] ==="Ativa" || props.dataItem[props.field] ==="Sim" || props.dataItem[props.field] ==="Processado" || props.dataItem[props.field] ==="Terminado" || props.dataItem[props.field] ==="Pedido Submetido" || props.dataItem[props.field] === "Concluído"){
                                return <td role="gridcell" style={{textAlign: 'left'}}><span data-role="badge" className='badge-sucess' >{props.dataItem[props.field]}</span></td>
                            }else if(props.dataItem[props.field] === "Anulado" || props.dataItem[props.field] === "Cancelado"||props.dataItem[props.field] === "Recusada" ||props.dataItem[props.field] === "Reprovado" || props.dataItem[props.field] === "Inativo" || props.dataItem[props.field] === "Erro"|| props.dataItem[props.field] === "Não"|| props.dataItem[props.field] === "Eliminada"){
                                return <td role="gridcell" style={{textAlign: 'left'}}><span data-role="badge" className='badge-Error' >{props.dataItem[props.field]}</span></td>
                            }else if(props.dataItem[props.field] === "Pendente" || props.dataItem[props.field] === "Submetido" || props.dataItem[props.field] === "Em edição" || props.dataItem[props.field] === "Processo em análise"){
                                return <td role="gridcell" style={{textAlign: 'left'}}><span data-role="badge" className='badge-Pendent-yellow' >{props.dataItem[props.field]}</span></td>
                            }else if(props.dataItem[props.field] === "Suspenso" || props.dataItem[props.field] ==="Aguarda Documento Transporte" || props.dataItem[props.field]=== "Recurso" ||props.dataItem[props.field]==="Aguarda Fiscalização" || props.dataItem[props.field]==="Processo em análise"|| props.dataItem[props.field]==="Suspensa" ||  props.dataItem[props.field]==="Em tratamento"){
                                return <td role="gridcell" style={{textAlign: 'left'}}><span data-role="badge" className='badge-Pendent' >{props.dataItem[props.field]}</span></td>
                            }else if(props.dataItem[props.field] === "Entregue"){
                                return <td role="gridcell" style={{textAlign: 'left'}}><span data-role="badge" className='badge-sucess2' >{props.dataItem[props.field]}</span></td>
                            }else{
                                return <td role="gridcell" style={{textAlign: 'left'}}>{props.dataItem[props.field]}</td>
                            }
                        }
                        else if(row.columnMenuType == "number") {
                          return <td role="gridcell" style={{textAlign: 'right'}}>{props.dataItem[props.field]}</td>
                        }
                        else{
                            return <td style={{textAlign: 'left'}}>{props.dataItem[props.field]}</td>
                        }
                      }}
                     />
            )
        }
        return tooltip;
    }

    

    Importar = () => {

    }

  
      
    /*  Para renderizar o conteúdo html da página   */

    render() {
        console.log("badge")
        actionTable = TabelAction({
                rowbuttonAction: this.rowbuttonAction,
                actionbuttons: this.props.actionbuttons,
                deleteFunc: this.props && this.props.deleteFunc && this.props.deleteFunc
            });
            // var pagesSizes = [this.state.result.total, 10, 20, 100];
            // if (this.state.result.total > 10){
            //     pagesSizes = [10, this.state.result.total, 20, 100];
            // }
            // if(this.state.result.total > 20){
            //     pagesSizes = [10, 20, this.state.result.total, 100];
            // }
            // if(this.state.result.total > 100){
            //     pagesSizes = [10, 20, 100, this.state.result.total];
            // }

        const grid = (
            <LocalizationProvider language="pt-PT">
            <IntlProvider locale="pt">
            <Grid
                className={this.props.forRutoloDetail ? "tlkTableSizeForRutolosDetail" : "tlkTableSize"}
                // style={{ maxHeight: '600px', minHeight: "550px" }}
                onColumnResize={this.onColumnResize}
                sortable={true}
                pageable={this.props.pageable === false ? false :{ pageSizes: [5, 10, 20, 100] }}
                resizable={true}
                reorderable={true}
                // groupable={this.props.notGroup ? false : true}
                groupable={this.props.MainModule == "Rotulo" || this.props.modulename == "RotulosNDResumoRegisto"  || this.props.modulename == "RotulosNDPHistoricoRotulos"  || this.props.modulename == "RotulosNDResumoRegistoDestino" || this.props.modulename == "RotulosNDResumoRegisto" || this.props.modulename == "detalhesTransferencia"? false :{ footer: "visible" }}                
                id="basic-table"
                data={this.state.result}
                {...this.state.dataState}
                onDataStateChange={this.dataStateChange}
                onExpandChange={this.expandChange}
                detail={this.props.collepsview ? DetailComponent : null}
                expandField="expanded"
                cellRender={this.cellRender}
                { ...(!!this.props.selection && { selectedField: 'selected', onSelectionChange: (e) => this.props.selectionChange(e)}) }
            >
                
                {
                    !this.props.noDownloadButton &&
                    this.props.list &&
                    this.props.list.length > 0 &&
                    <GridToolbar>
                      { !!this.props.toolbarHTML && (
                        <span className="d-inline-block toolbar-text">{ this.props.toolbarHTML }</span>
                      ) }
                        <Button
                            title="Export PDF"
                            primary={true}
                            className={`btn-ivdp-primary download-pdf ${(!!this.props.MainModule && this.props.MainModule === "Rotulo" || this.props.modulename === "Conta Corrente") ? '' : 'mt-3 mr-2'} btn-sm float-right`}
                            // onClick={this.exportPDF}
                            disabled={this.state.exporting}

                        >
                            {"Exportar para Pdf"}
                        </Button>
                        <Button
                            title="Export Excel"
                            primary={true}
                            className={`btn-ivdp-primary mr-2 ${(!!this.props.MainModule && this.props.MainModule === "Rotulo" || this.props.modulename === "Conta Corrente") ? '' : 'mt-3'} btn-sm float-right`}
                            onClick={this.export}
                            disabled={this.state.exporting}
                        >
                            {"Exportar para Excel"}
                        </Button>
                        <Button
                            title="Limpar Filtros"
                            primary={true}
                            className={`btn-ivdp-primary mr-2 ${(!!this.props.MainModule && this.props.MainModule === "Rotulo" || this.props.modulename === "Conta Corrente") ? '' : 'mt-3'} btn-sm float-right`}
                            onClick={this.clearFilters}
                            //disabled={this.state.exporting}
                        >
                            {"Limpar Filtros"}
                        </Button>

                    </GridToolbar>
                }
                {/* {
                            this.props.Importarbutton &&

                            <Button
                                title="Importar dados"
                                primary={true}
                                className="k-button mr-2 btn-sm float-right"
                                onClick={this.Importar()}
                            >
                                {"Importar dados".toUpperCase()}
                            </Button>
                } */}

                {
                    this.props.generateDocument && this.props.list && this.props.list.length > 0 &&
                    <GridToolbar>
                        <Button
                            title="Gerar Documento"
                            primary={true}
                            className="btn-ivdp-primary mr-2 btn-sm float-right"
                            onClick={this.generateDocument}
                        >
                            {"Gerar Documento".toUpperCase()}
                        </Button>
                    </GridToolbar>
                }
                {
                    this.props.DocumentGERFIP && this.props.list && this.props.list.length > 0 &&
                    <GridToolbar>
                        <Button
                            title="Gerar Documento"
                            primary={true}
                            className="btn-ivdp-primary mr-2 btn-sm float-right"
                            onClick={this.grepif}
                        >
                            {"GERFIP".toUpperCase()}
                        </Button>
                    </GridToolbar>
                }
                {
                    this.props.novo &&
                    <GridToolbar>
                        <Button
                            title="Novo"
                            primary={true}
                            className="btn-ivdp-primary btn-sm novobutton"
                            onClick={this.export}
                        >
                            {"Novo".toUpperCase()}
                        </Button>
                    </GridToolbar>
                }

                {

                    this.props.columnlist.map((_row, index) => (
                        this.Tooltip(_row, index)
                    ))
                }
                {
                    !this.props.notAction && !this.state.exporting &&
                    <Column
                    //width={this.state.columnWidths[row.field] || 220}
                       // width={this.props.actionColWidth || this.state.per_col_width}
                        field={Lang.langCheck.langRequest(this.props.actionColumnName || "Action")}
                        // cell={this.TabelAction}
                        cell={actionTable}
                        style={{ minWidth: "200px" }}
                    />
                }
                {
                  this.props.selection &&
                  <Column field="selected" />
                }
            </Grid>
            </IntlProvider>
            </LocalizationProvider>
        );

        return (

            // <LocalizationProvider language="pt-PT">
            <>
                {/* <IntlProvider locale="pt-PT" > */}
                <>
                    <PDFGenerate columnlist={this.props.columnlist} dataList={this.getOnlyData()} pdfTitle={this.props.pdfTitle}/>
                    <GridPDFExport
                        ref={pdfExport => this.gridPDFExport = pdfExport}
                        margin="1cm"
                    >
                        {grid}
                    </GridPDFExport>
                    <ExcelExport
                        data={list}
                        ref={exporter => this._export = exporter}
                    >
                        {grid}
                    </ExcelExport>
                    {/* </IntlProvider> */}
                </>
                {
                    this.props.sendDatatoTlkTable &&
                    <Mainfilter
                        dataState={this.state.dataState}
                        onDataRecieved={this.dataRecieved}
                        sendDatatoTlkTable={(filter) => this.props.sendDatatoTlkTable(filter)}
                    />
                }
            </>
            // </LocalizationProvider>
        )
    }
}
export default TlkTable;